/**
 * Toggle whether the background/body can scroll (used in dialogs)
 * @param  {boolean} isEnabled Whether background can scroll
 */
const toggleBackgroundScroll = isModalShown => {
  document.body.style.overflow = isModalShown ? "hidden" : "auto";
};

export { toggleBackgroundScroll };



// WEBPACK FOOTER //
// ./src/common/utilities.js